import { createApiBody } from '../../../api/api';
import call from '../../../api/axios';

export async function FetchClientQuotations(data) {
	const body = createApiBody(
		'client',
		'quotation',
		'fetchClientQuotations',
		data,
	);
	const res = await call.post('', body);

	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function FetchClientPolicies(data) {
	const body = createApiBody('client', 'policy', 'fetchClientPolicies', data);
	const res = await call.post('', body);

	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function FetchPolicyDetails(data) {
	const body = createApiBody('client', 'policy', 'policyDetails', data);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function ManualPayment(data) {
	const body = createApiBody(
		'underwriting',
		'quotation',
		'manualQuotationPayment',
		data,
	);

	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function FetchClientInvoices(data) {
	const body = createApiBody(
		'client',
		'invoice',
		'fetchClientInvoices',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function FetchInvoiceDetails(ref) {
	const body = createApiBody(
		'underwriting',
		'accounting',
		'invoiceDetails',
		ref,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function FetchWallets() {
	const body = createApiBody('entity', 'wallet', 'fetchEntityWallets', {});
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function fetchWalletTransactionsApi(data) {
	const body = createApiBody(
		'entity',
		'wallet',
		'fetchWalletTransactions',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function bookAppointmentApi(data) {
	const body = createApiBody(
		'underwriting',
		'appointment',
		'clientAppointmentRequest',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}
export async function fecthClientAppointments(data) {
	const body = createApiBody(
		'underwriting',
		'appointment',
		'listAppointmentsCreatedByClient',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}
export async function fecthIntermediaryAppointments(data) {
	const body = createApiBody(
		'underwriting',
		'appointment',
		'listAppointmentsCreatedForClient',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}
export async function fetchAppointmentDetails(data) {
	const body = createApiBody(
		'underwriting',
		'appointment',
		'getAppointmentRequest',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function acceptAppointmentRequest(data) {
	const body = createApiBody(
		'underwriting',
		'appointment',
		'acceptAppointmentRequest',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function rejectAppointmentRequest(data) {
	const body = createApiBody(
		'underwriting',
		'appointment',
		'clientRejectionAppointmentRequest',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function makeRenewalRequest(data) {
	const body = createApiBody('client', 'policy', 'renewal', data);

	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function acceptRenewalRequest(data) {
	const body = createApiBody('client', 'policy', 'AcceptRenewal', data);

	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function rejectRenewalRequest(data) {
	const body = createApiBody('client', 'policy', 'RejectRenewal', data);

	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function submitReviewApi(data) {
	const body = createApiBody(
		'underwriting',
		'product-review',
		'createProductReview',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function fetchProductReviewsApi(data) {
	const body = createApiBody(
		'underwriting',
		'product-review',
		'fetchProductReviews',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}
